import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components

import SubTitleContents from "reusables/TextFormats/SubTitleContents";
import CheckList_TwoColumns from "reusables/TextFormats/CheckList_TwoColumns";

function Office_Section2() {
  const titlesDescriptionsObj = {
    "Boosts Productivity":
      "A tidy and clutter-free environment helps employees stay focused and efficient. Regular cleaning minimizes distractions and enhances the overall work atmosphere.",
    "Promotes Health and Hygiene":
      "Offices are high-traffic areas that can harbor germs and bacteria. Regular cleaning reduces the spread of illnesses, ensuring a healthier workplace for your team.",
    "Enhances Professional Image":
      "A clean and polished office space leaves a lasting impression on clients, customers, and business partners, showcasing your commitment to professionalism.",
    "Maintains Equipment and Furniture":
      "Dust and dirt buildup can damage office furniture, electronics, and other assets over time. Routine cleaning helps preserve the quality and longevity of your office investments.",
    "Improves Air Quality":
      "Regular cleaning, including vacuuming and dusting, enhances indoor air quality, contributing to a more comfortable and healthier workspace for everyone.",
    "Boosts Employee Morale":
      "A clean and organized office creates a welcoming atmosphere, making employees feel valued and motivated to perform at their best.",
  };
  return (
    <Container>
      <Grid container alignItems="center">
        <Grid item display={"flex"} flexDirection={"column"}>
          <Grid item>
            <SubTitleContents
              title="Why Regular Cleaning is Essential for Your Workspace?"
              contents="A clean and organized workspace goes beyond just appearances—it’s essential for fostering productivity, maintaining employee well-being, and creating a positive impression on clients and visitors. Here’s why regular office cleaning is crucial:"
            />
          </Grid>
          <Grid item>
            <CheckList_TwoColumns titlesDescriptionsObj={titlesDescriptionsObj} />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Office_Section2;
